// src/components/Navbar.js
import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { signOut } from '../lib/supabase'
import { useLang } from '../lib/i18n'
import LanguageSwitcher from './LanguageSwitcher'
import './Navbar.css'

export default function Navbar({ chatUnread = 0, amaUnread = 0 }) {
  const { session, profile } = useAuth()
  const navigate = useNavigate()
  const { t } = useLang()
  const totalUnread = chatUnread + amaUnread
  const tierClass = profile?.tier || 'gold'

  async function handleSignOut() {
    await signOut()
    navigate('/')
  }

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <Link to={session ? '/dashboard' : '/'} className="navbar__logo">
          <span className="navbar__logo-sky">Sky</span>
          <span className="navbar__logo-bri"> Bri</span>
          <span className="navbar__logo-dot">·</span>
          <span className="navbar__logo-sub">PRIVATE</span>
        </Link>

        <div className="navbar__right">
          <LanguageSwitcher />

          {session && profile ? (
            <>
              {totalUnread > 0 && (
                <Link to="/dashboard" className="navbar__notif" title="Unread messages">
                  <span className="navbar__notif-dot" />
                  <span className="navbar__notif-count">{totalUnread}</span>
                </Link>
              )}
              <span className={`badge badge--${tierClass}`}>
                {profile.tier.charAt(0).toUpperCase() + profile.tier.slice(1)}
              </span>
              <button className="btn btn--ghost btn--sm" onClick={handleSignOut}>
                {t('signOut')}
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn--ghost btn--sm">{t('login')}</Link>
              <Link to="/join"  className="btn btn--outline btn--sm">{t('join')}</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  )
}
